module.exports = __webpack_public_path__ + "img/logo-14.5ed45cd.jpg";